import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_candles_holders_all: FaireCategoryEntity = {
  token: "cat_candles-holders-all",
  type: "category",
  name: "All candles & holders",
  level: 3,
  parentToken: "cat_home-decor-candles",
  href: "/category/home-decor/candles-holders",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
